import { render, staticRenderFns } from "./PricePackage.vue?vue&type=template&id=65689d56&scoped=true"
import script from "./PricePackage.vue?vue&type=script&lang=js"
export * from "./PricePackage.vue?vue&type=script&lang=js"
import style0 from "./PricePackage.vue?vue&type=style&index=0&id=65689d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65689d56",
  null
  
)

export default component.exports